import { Model } from 'pinia-orm'
import { Attr } from 'pinia-orm/dist/decorators'

export default class RoleHasPermission extends Model {
  static override entity = 'role_has_permissions'
  static primaryKey = ['role_id', 'permission_id']

  // Fields
  @Attr('') declare id: string

  @Attr() declare role_id: string | null
  @Attr() declare permission_id: string | null

  // Relationships
}
